const styles = {
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
    map: {
        height: 300
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/types/EditTypePage/EditTypePage.css.js